<!-- @veltra/icons generated sha256:3e0e96ec3efb71f7 gen:8 source:src/svg/normal/horn.svg -->
<script setup lang="ts">
defineOptions({ name: 'Horn' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m4 11 4.243 2.546a.5.5 0 0 0 .757-.43V2.884a.5.5 0 0 0-.757-.429L4 5H2.105a.6.6 0 0 0-.6.6L1.5 10.4a.6.6 0 0 0 .6.6zm1-5.434 3-1.8v8.468l-3-1.8zM4 10H2.5l.004-4H4zm8.47-5.866a5.9 5.9 0 0 1 1.045 1.593C13.835 6.45 14 7.222 14 8s-.164 1.55-.485 2.273a6 6 0 0 1-1.045 1.593c-.186.204-.207.505-.018.707l.02.022a.464.464 0 0 0 .686 0 7 7 0 0 0 1.271-1.916 6.6 6.6 0 0 0 0-5.358 7 7 0 0 0-1.271-1.916.464.464 0 0 0-.686 0l-.02.022c-.189.202-.168.503.018.707m-1.712 1.781c.494.629.743 1.36.742 2.085a3.37 3.37 0 0 1-.746 2.084.554.554 0 0 0 .021.729l.008.008c.194.197.503.19.68-.022C12.14 9.983 12.499 9 12.5 8s-.357-1.982-1.032-2.799a.452.452 0 0 0-.68-.023l-.008.008a.554.554 0 0 0-.022.728"
    />
  </svg>
</template>
